class None { }

export default (Class = None) => class Subscribable extends Class {
    constructor(...args) {
        super(...args);

        this._subscriptions = {};
    }

    on(name, callback) {
        let subscriptions = this._subscriptions[name] || [];
        subscriptions.push(callback);

        this._subscriptions[name] = subscriptions;

        return () => {
            let index = this._subscriptions[name].indexOf(callback);
            if (index >= 0) {
                this._subscriptions[name][index].splice(index, 1);
            }
        };
    }

    fire(name, data) {
        let callbacks = this._subscriptions[name] || [];
        callbacks.forEach((callback) => callback(data));
    }
};



// WEBPACK FOOTER //
// ./src/common/provider/subscribable.provider.js